import { gql } from "@apollo/client";

export const GET_PROGRAMS_PAGINATED = gql`
query GetProgramsPaginated(
    $skip: Int
    $take: Int
    $where: ProgramaFilterInput
) {
    programs(skip: $skip, take: $take, where: $where)
    {
        items {
            idPrograma
            idSubTipoPrograma
            nombre
            activo
            idSubTipoProgramaNavigation {
                nombre
                idTipoPrograma
                programa {
                    nombre
                }
                idTipoProgramaNavigation {
                    nombre
                }
            }
        }
        pageInfo {
            hasNextPage
            hasPreviousPage
        }
        totalCount
    }
}`;